export default __webpack_public_path__ + "static/media/apple_help_4.7de152c1.png";